import axios from 'axios'
import { useUser } from '@/stores/user'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const apiBaseURL = config.public.apiBase
  const { removeUserInfo } = useUser()

  const api = axios.create({
    baseURL: apiBaseURL,
  })

  // Request Interceptor
  api.interceptors.request.use(
    (config) => {
      const phiethoc_token = useCookie('phiethoc_client', {
        path: '/',
        sameSite: 'strict',
        secure: process.env.NODE_ENV === 'production',
      })
      if (phiethoc_token) {
        config.headers.Authorization = `Bearer ${phiethoc_token.value}`
      }
      return config
    },
    (error) => Promise.reject(error),
  )

  // Response Interceptor
  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      const phiethoc_token = useCookie('phiethoc_client')
      const originalRequest = error.config

      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true
        // try {
        //     await useUser.refreshToken()
        //     originalRequest.headers['Authorization'] = `Bearer ${authStore.accessToken}`
        //     return api(originalRequest)
        // } catch (refreshError) {
        //     authStore.logout()
        // }
        removeUserInfo() // Ensure user is logged out on 401 error
      }
      return Promise.reject(error)
    },
  )
  return {
    provide: {
      api,
    },
  }
})
